<template>
  <div class="wrap">
    <div class="bannerimg relative">
      <img
        style="height: 480px"
        src="@/assets/image/lunbo/lunbo2.png"
        alt=""
        class="w-full"
      />
      <div
        class="biaotowenzi absolute top-1/2 left-1/4 -translate-y-1/2 text-white text-left p-5 z-2"
      >
        <h2 class="text-6xl">信息与通信方案服务提供商</h2>
        <br />
        <p class="text-lg">诚信、务实、创新、进取</p>
      </div>
    </div>

    <div class="nav-placeholder"></div>
    <Nav
      class="fixed-nav"
      :nav-items="[
        {
          id: 1,
          title: '公司介绍',
          path: '/workspace#intro',
          anchor: '#intro',
        },
        {
          id: 2,
          title: '发展历程',
          path: '/workspace#history',
          anchor: '#history',
        },
        {
          id: 3,
          title: '合作伙伴',
          path: '/workspace#partners',
          anchor: '#partners',
        },
        {
          id: 4,
          title: '公司资质',
          path: '/workspace#certificates',
          anchor: '#certificates',
        },
        { id: 5, title: '公司动态', path: '/workspace#news', anchor: '#news' },
        {
          id: 6,
          title: '联系我们',
          path: '/workspace#contact',
          anchor: '#contact',
        },
      ]"
      :active-anchor="activeAnchor"
      @nav-change="handleNavChange"
    />

    <div class="news-detail-bg">
      <div class="news-detail-main">
        <div class="news-detail-title">{{ news.title }}</div>
        <div class="news-detail-meta">
          <br />
          <hr />
          <br /><br />
          <span
            ><router-link
              to="/workspace#news"
              style="color: #888; text-decoration: none"
              >公司动态</router-link
            ></span
          >
          <span class="meta-date">{{ formatDate(news.eventDate) }}</span>
        </div>
        <div v-if="news.imageUrl" class="news-detail-img-wrap">
          <img :src="getFullImageUrl(news.imageUrl)" class="news-detail-img" />
        </div>
        <div class="news-detail-content" v-html="news.content"></div>
        <div class="news-detail-nav">
          <div class="news-detail-prev">
            上一篇：
            <span v-if="prevId">
              <router-link :to="`/news/newsDetail${prevId}`">{{
                prevTitle
              }}</router-link>
            </span>
            <span v-else>暂无</span>
          </div>
          <div class="news-detail-next">
            下一篇：
            <span v-if="nextId">
              <router-link :to="`/news/newsDetail${nextId}`">{{
                nextTitle
              }}</router-link>
            </span>
            <span v-else>暂无</span>
          </div>
        </div>
      </div>
    </div>
    <Footer class="workspace-footer" :show="true" />
  </div>
</template>

<script>
import newsApi from "@/api/news";
import Nav from "../../components/Nav/Nav.vue";
import Footer from "../../components/Footer/index.vue";
import { debounce } from "lodash";
import { getDynamicDetail, getDynamicList } from "@/api/api.js";

export default {
  name: "NewsDetail",
  components: {
    Nav,
    Footer,
  },
  data() {
    return {
      news: {},
      loading: true,
      error: null,
      prevId: "",
      nextId: "",
      prevTitle: "",
      nextTitle: "",
      activeAnchor: "#intro",
      dynamicList: [],
    };
  },
  async created() {
    const id = this.$route.params.id;
    try {
      const res = await getDynamicDetail(id);
      this.news = res.data || {};
      // 获取所有新闻列表数据
      const listRes = await getDynamicList();
      this.dynamicList = listRes.rows;
      this.setPrevNextNews();
    } catch (e) {
      this.error = "获取详情失败";
    } finally {
      this.loading = false;
    }
    this.fetchTop5News();
  },
  watch: {
    $route(to, from) {
      this.loadNews();
    },
  },
  mounted() {
    this.getDynamicList();
    window.addEventListener("scroll", this.handleScroll);
    const handleAnchor = () => {
      if (window.location.hash) {
        this.activeAnchor = window.location.hash;
        const element = document.querySelector(window.location.hash);
        if (element) {
          setTimeout(() => {
            element.scrollIntoView({
              behavior: "smooth",
            });
          }, 100);
        }
      } else {
        this.handleScroll();
      }
    };
  },

  methods: {
    // 添加图片URL处理方法
    getFullImageUrl(url) {
      if (!url) return "";
      if (url.startsWith("http")) return url;
      // 彻底去除多余斜杠
      return [process.env.VUE_APP_BASE_API, url]
        .map(str => str.replace(/^\/+|\/+$/g, ""))
        .join("/");
    },
    async getDynamicList() {
      const response = await getDynamicList();
      this.dynamicList = response.rows;
      this.dynamicTotal = response.total;
      console.log(response.data);
    },
    scrollToAnchor(anchor) {
      const element = document.querySelector(anchor);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }, 100);
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return "";
      const [y, m, d] = dateStr.split("-");
      return `${y}年${m}月${d}日`;
    },
    handleNavChange(item) {
      if (item.anchor) {
        this.activeAnchor = item.anchor;
        this.scrollToAnchor(item.anchor);
        history.pushState(null, null, item.anchor);
      }
    },
    async loadNews() {
      const id = this.$route.params.id;
      try {
        const res = await getDynamicDetail(id);
        this.news = res.data || {};
        // 替换 content 里的图片链接
        if (this.news.content) {
          let result = this.news.content.replace(/http:\/\/localhost:80\/\/profile\/upload/g, "http://www.phcloud.com.cn/prod-api/profile/upload");
          result = result.replace(/src=\"\/\/profile\/upload/g, 'src="http://www.phcloud.com.cn/prod-api/profile/upload');
          result = result.replace(/src=\"\/profile\/upload/g, 'src="http://www.phcloud.com.cn/prod-api/profile/upload');
          this.news.content = result;
        }
        // 获取所有新闻列表数据
        if (!this.dynamicList.length) {
          const listRes = await getDynamicList();
          this.dynamicList = listRes.rows;
        }
        this.setPrevNextNews();
      } catch (e) {
        this.error = "获取详情失败";
      } finally {
        this.loading = false;
      }
    },

    handleScroll: debounce(function () {
      const sections = [
        "#intro",
        "#history",
        "#partners",
        "#certificates",
        "#news",
        "#contact",
      ];
      const scrollPosition = window.scrollY + 1135;
      let currentSection = "#intro";
      for (const section of sections) {
        const element = document.querySelector(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;
          if (
            scrollPosition >= offsetTop - 280 &&
            scrollPosition < offsetTop + offsetHeight - 280
          ) {
            currentSection = section;
            break;
          }
        }
      }
      if (this.activeAnchor !== currentSection) {
        this.activeAnchor = currentSection;
      }
    }, 100),

    setPrevNextNews() {
      const currentId = Number(this.$route.params.id);
      // 建议按 id 降序或 eventDate 降序排序
      this.dynamicList.sort((a, b) => Number(b.id) - Number(a.id));
      const currentIndex = this.dynamicList.findIndex(
        (item) => Number(item.id) === currentId
      );
      // 上一篇
      if (currentIndex > 0) {
        const prevNews = this.dynamicList[currentIndex - 1];
        this.prevId = prevNews.id;
        this.prevTitle = prevNews.title;
      } else {
        this.prevId = "";
        this.prevTitle = "";
      }
      // 下一篇
      if (currentIndex < this.dynamicList.length - 1 && currentIndex !== -1) {
        const nextNews = this.dynamicList[currentIndex + 1];
        this.nextId = nextNews.id;
        this.nextTitle = nextNews.title;
      } else {
        this.nextId = "";
        this.nextTitle = "";
      }
    },
  },
  async created() {
    await this.loadNews();
  },
};
</script>

<style scoped>
.news-detail-bg {
  background: #fff;
  min-height: 600px;
  padding-bottom: 60px;
}
.news-detail-main {
  max-width: 1100px;
  margin: 0 auto;
  background: #fff;
  padding: 48px 0 60px 0;
  box-sizing: border-box;
}
.image-nav {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 10px;
}
.image-nav .nav-item {
  width: 60px;
  height: 40px;
  cursor: pointer;
  opacity: 0.7;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.image-nav .nav-item:hover,
.image-nav .nav-item.active {
  opacity: 1;
  border-color: #fff;
}

.image-nav img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.news-detail-title {
  font-weight: 500;
  color: #222;
  margin-bottom: 22px;
  text-align: left;
  line-height: 1.3;
}
.news-detail-meta {
  color: #888;
  font-size: 14px;
  margin-bottom: 28px;
  text-align: left;
}
.news-detail-meta .meta-date {
  margin-left: 22px;
}
.news-detail-img-wrap {
  margin-bottom: 32px;
  text-align: left;
}
.news-detail-img {
  max-width: 420px;
  width: 100%;
  border-radius: 0;
  display: block;
}
.news-detail-content {
  font-size: 19px;
  color: #333;
  margin-bottom: 48px;
  text-align: left;
  line-height: 1.8;
}
.news-detail-nav {
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  font-size: 16px;
  color: #222;
  margin-top: 18px;
}
.news-detail-nav a {
  color: #ff4d4f;
  text-decoration: none;
  font-weight: 500;
}
.news-detail-nav a:hover {
  text-decoration: underline;
}
.news-detail-prev,
.news-detail-next {
  text-align: left;
}
.wrap {
  width: 100%;
}

.bannerimg {
  position: relative;
}

.bannerimg .biaotowenzi {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  color: white;
  text-align: left;
  max-width: 80%;
  padding: 20px;
  z-index: 2;
}

.bannerimg .biaotowenzi h2 {
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0px;
  /* line-height: 101.36px; */
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.bannerimg .biaotowenzi p {
  font-size: 22px;
  font-weight: 500;
  letter-spacing: 0px;
  /* line-height: 30px; */
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}

.news-detail-bg {
  background: #fff;
  min-height: 100vh;
  padding: 20px 0;
  width: 100%;
}

.news-detail-main {
  max-width: 1440px;
  margin: 0 auto;
  background: #fff;
  padding: 40px 20px;
  box-sizing: border-box;
}

.news-detail-title {
  font-size: 30px;
  font-weight: 700;
  color: #222;
  margin-bottom: 22px;
  text-align: left;
  line-height: 1.3;
  letter-spacing: 0px;
}

.news-detail-meta {
  color: #888;
  font-size: 14px;
  margin-bottom: 28px;
  text-align: left;
}

.news-detail-meta .meta-date {
  margin-left: 22px;
}

.news-detail-img-wrap {
  margin-bottom: 32px;
  text-align: left;
}

.news-detail-img {
  max-width: 100%;
  width: auto;
  height: auto;
  border-radius: 0;
  display: block;
}

.news-detail-content {
  font-size: 19px;
  color: #333;
  margin-bottom: 48px;
  text-align: left;
  line-height: 1.8;
}

.news-detail-nav {
  display: flex;
  justify-content: flex-start;
  gap: 40px;
  font-size: 16px;
  color: #222;
  margin-top: 18px;
}

.news-detail-nav a {
  color: #f44336;
  text-decoration: none;
  font-weight: 500;
}

.news-detail-nav a:hover {
  text-decoration: underline;
}

.news-detail-prev,
.news-detail-next {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/view/Match/NewsDetail.vue